/*
 * Stub for react-native-screens for webpack
 * so web builds don't fail
 */
export default {};

export const createNativeStackNavigator = (): void => {
  // Stub function for web
};
export const enableScreens = (enable: boolean): void => {
  // Stub function for web
};
